// @flow
import * as React from 'react';

import Button from '../../button';
import settings from '../../settings';

import cs from './styles.pcss';
import t from './locale';

export default function SignInButton(): React.Node {
  return (
    <div className={cs.signInButton}>
      <Button
        mode="secondary"
        size="small"
        href={settings.signIn}
        area="header"
        className={cs.buttonMobile}
      >
        {t('buttonText')}
      </Button>
      <Button
        mode="primary"
        size="small"
        href={settings.signIn}
        area="header"
        className={cs.buttonDesktop}
        withArrow
      >
        {t('buttonTextDesktop')}
      </Button>
    </div>
  );
}
